export default "__VITE_ASSET__0oXprhgi__"